export const portalI18n = {
  en: {
    calendar: 'Calendar',
    im: 'IM',
    grades: 'Grades',
    tasks: 'Tasks',
    meetings: 'Present',
    calls: 'Calls'
  },
  es: {
    calendar: 'Calendario',
    im: 'IM',
    grades: 'Calificaciones',
    tasks: 'Tareas',
    meetings: 'Reuniones',
    calls: 'Llamadas'
  }
};